import { render, staticRenderFns } from "./orgStockDayByInvAddCode.vue?vue&type=template&id=36dec941&scoped=true&"
import script from "./orgStockDayByInvAddCode.vue?vue&type=script&lang=js&"
export * from "./orgStockDayByInvAddCode.vue?vue&type=script&lang=js&"
import style0 from "./orgStockDayByInvAddCode.vue?vue&type=style&index=0&id=36dec941&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dec941",
  null
  
)

export default component.exports